import * as monacoEditor from 'monaco-editor';
import { useEffect } from 'react';

import { applyClassNameToRanges } from '../helpers/monacoHelpers';

/**
 * Hook to apply class names to ranges in the editor.
 */
export const useInlineClassRangesEffect = ({
  className,
  editor,
  ranges,
  skip = false,
}: {
  className: string;
  editor: monacoEditor.editor.IStandaloneCodeEditor;
  ranges: monacoEditor.Range[] | undefined;
  skip?: boolean;
}) => {
  useEffect(() => {
    if (!skip) {
      return applyClassNameToRanges(className, editor, ranges);
    }
  }, [editor, skip, ranges, className]);
};
